<template>
  <div class="noPrivBody">
    <div class="errPage-container">
      <img
        :src="noPrivImg"
        class="noPrivImg"
      />
      <div class="sk-content sk-content-pre" v-if="!text&&appText" v-html="appText"></div>
      <span class="text" v-else>{{ text ? text : noPermissions }}</span>
      <el-button
        v-if="isGoLogin||isGoBack=='true'"
        style="margin-top: 20px"
        type="primary"
        round
        @click="goHome"
      >返回登录页</el-button>
    </div>
  </div>
</template>
<script>
import "@wangeditor/editor/dist/css/style.css";
import { mapGetters } from "vuex";
import { auth } from "common";
export default {
  name: "no-access",
  props: {
    text: {
      type: String,
      default: "",
    },
    isGoLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noPrivImg: require("../assets/images/no_priv.png"),
      noPermissions: "暂无访问权限，请联系管理员！",
      isGoBack: false,
      appText:``
    };
  },
    computed: {
    ...mapGetters([ "appBasicData"]),
  },
  created() {
    if (this.$route.query.isGoBack != undefined) {
      this.isGoBack = this.$route.query.isGoBack;
    }
    let appData = auth.getAppStorage("app_basic")||{};
    this.appText=appData.noPermissionMsg
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>
<style scoped>
.errPage-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
}
.text {
  margin-top: 20px;
  color: #898b97;
}
.sk-content{
  margin-top: 20px;
}
</style>
